export default "__VITE_ASSET__DRCH1uyL__"